<template>
    <el-dialog
            :visible.sync="showDlg"
            :fullscreen=true
            :lock-scroll="false"
            :append-to-body="true"
            :close-on-click-modal="false"
            class="dlg-normal cls-main">
        <template slot="title">
            <div style="height: 24px;">
                <span class="el-dialog__title">{{title}}</span>
            </div>
            <div class="cls-btn-save">
                <span v-if="hasBaseMchStore" class="cls-tag-btn cls-tag3btn" @click="readTemp"><i class="el-icon-monitor"/> 读取缓存</span>
                <span v-else class="cls-tag-btn cls-tag4btn" @click="saveTemp"><i class="el-icon-milk-tea"/> 暂存表单</span>
            </div>
        </template>

        <div class="main-form-mch-dlg">
            <el-form :model="mchInfo" ref="baseMainFormRef" :rules="baseMainFormRules" label-position="top">
                <el-tabs class="cls-tabs" v-model="stepTab">
                    <el-tab-pane label="商户信息" name="0"  v-if="showMchTab" >
                        <div>
                            <div class="tipTitle">基本信息</div>
                            <div class="form-s">
                                <el-row :gutter="30">
                                    <el-col :span="c1">
                                        <el-form-item label="商户性质" prop="mchExtraInfo.nature">
                                            <el-select v-model="mchInfo.mchExtraInfo.nature" placeholder="请先选择商户性质" size="small"
                                                       style="width: 100%;">
                                                <el-option
                                                        v-for="item in _enums.MchNatureEnum"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <div v-if="mchInfo.mchExtraInfo.nature && loadFinish"> <!-- v-if="mchInfo.mchExtraInfo.nature" -->


                                    <el-row :gutter="30">
                                        <el-col :span="c1" v-if="this.mchInfo.mchExtraInfo.nature!==this._enums.MchNatureEnum.小微商户.id">
                                            <el-form-item label="营业执照图片" prop="mchExtraInfo.imgBusinessFUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgBusinessFUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgBusinessFUrl" @onImgUpSuc="onImgUpSucBiz" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="法人证件正面照" prop="mchExtraInfo.imgLegalIdCardFUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgLegalIdCardFUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgLegalIdCardFUrl" @onImgUpSuc="onImgUpSucIdCard" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="法人证件反面照" prop="mchExtraInfo.imgLegalIdCardBUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgLegalIdCardBUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgLegalIdCardBUrl" @onImgUpSuc="onImgUpSucIdCard" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="法人手持证件正面照"> <!-- prop="mchExtraInfo.imgLegalIdCardHUrl"-->
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgLegalIdCardHUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgLegalIdCardHUrl" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="c1">
                                            <el-form-item label="门店店面照" prop="mchExtraInfo.imgShopOutsideUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgShopOutsideUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgShopOutsideUrl" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="门店店内照" prop="mchExtraInfo.imgShopInsideUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgShopInsideUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgShopInsideUrl" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="门店收银台照" prop="mchExtraInfo.imgShopCashRegisterUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgShopCashRegisterUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgShopCashRegisterUrl" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="门店商品照"> <!-- prop="mchExtraInfo.imgShopGoodsUrl"-->
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgShopGoodsUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgShopGoodsUrl" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>


                                    <el-row :gutter="30">
                                        <el-col :span="c1" v-show="false">
                                            <el-form-item label="商户ID" prop="id">
                                                <el-input size="small" v-model="mchInfo.id" placeholder="系统自动生成" :disabled="true"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="商户名称" prop="mchName">
                                                <el-input size="small" v-model="mchInfo.mchName" placeholder="商户名称" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="商户简称" prop="shortName">
                                                <el-input size="small" v-model="mchInfo.shortName" placeholder="商户简称" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="经营类目" prop="mchExtraInfo.businessId">
                                                <el-cascader v-model="businessArr" filterable ref="refBusiness" @change="onBusinessChanged"
                                                             :options="enum_mchExtraInfoBusinessId" :show-all-levels="false" style="width: 100%;" placeholder="经营类目">
                                                </el-cascader>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="主体类型" prop="mchExtraInfo.companyType">
                                                <el-select v-model="mchInfo.mchExtraInfo.companyType" placeholder="主体类型" size="small"
                                                           style="width: 100%;">
                                                    <el-option
                                                            v-for="item in _enums.CompanyTypeEnum"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="c2">
                                            <el-form-item label="地区" prop="mchExtraInfo.tempAreas">
                                                <AreaSelect :key="compAreaKey" v-bind:inAreas="mchInfo.mchExtraInfo.tempAreas" @onAreasChanged="onAreasChanged" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c2">
                                            <el-form-item label="详细地址" prop="mchExtraInfo.adsAddress">
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.adsAddress" placeholder="详细地址" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="c1">
                                            <el-form-item label="法人姓名" prop="mchExtraInfo.legalName">
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.legalName" placeholder="法人姓名" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="法人电话" prop="mchExtraInfo.legalPhone">
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.legalPhone" placeholder="法人电话" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="法人身份证号" prop="mchExtraInfo.legalIdCardNo" >
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.legalIdCardNo" placeholder="法人身份证号" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="* 法人证件有效期">
                                    <span slot="label">* 法人证件有效期&nbsp;
                                    <el-checkbox v-model="mchInfo.tempFilter.legalIdExpDateNon" size="small" style="color: red;"><span style="font-weight:bold;font-size: 12px;">永久有效</span></el-checkbox>
                                    </span>
                                                <el-form-item prop='mchExtraInfo.legalIdCardForceDate'>
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: auto" placeholder="生效期"
                                                                    v-model="mchInfo.mchExtraInfo.legalIdCardForceDate" />
                                                </el-form-item>
                                                <el-form-item>-</el-form-item>
                                                <el-form-item prop='mchExtraInfo.legalIdCardExpDate' :rules="rulesRespIsLegal_mchExtraInfo_legalIdCardExpDate">
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: auto" placeholder="有效期"
                                                                    v-model="mchInfo.mchExtraInfo.legalIdCardExpDate"
                                                                    :disabled="this.mchInfo.tempFilter.legalIdExpDateNon" />
                                                </el-form-item>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="c1">
                                            <el-form-item label="负责人姓名" prop="mchExtraInfo.responsibleName" :rules="rulesRespIsLegal_mchExtraInfo_responsibleName" >
                                                <el-checkbox v-model="mchInfo.tempFilter.respIsLegal" border size="small" style="color: red; font-weight: bold">同法人</el-checkbox>
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.responsibleName" placeholder="负责人姓名" :disabled="this.mchInfo.tempFilter.respIsLegal" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="负责人电话" prop="mchExtraInfo.responsiblePhone" :rules="rulesRespIsLegal_mchExtraInfo_responsiblePhone" >
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.responsiblePhone" placeholder="负责人电话" :disabled="this.mchInfo.tempFilter.respIsLegal" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="负责人证件号" prop="mchExtraInfo.responsibleIdCardNo" :rules="rulesRespIsLegal_mchExtraInfo_responsibleIdCardNo" >
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.responsibleIdCardNo" placeholder="负责人证件号" :disabled="this.mchInfo.tempFilter.respIsLegal" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="c1">
                                            <el-form-item label="联系邮箱" prop="mchExtraInfo.responsibleEmail">
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.responsibleEmail" placeholder="联系邮箱" type="email"/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="客服电话" > <!--prop="mchExtraInfo.servicePhone"-->
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.servicePhone" placeholder="客服电话" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="签约人手机号" > <!--prop="mchExtraInfo.remark"-->
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.remark" placeholder="若渠道不允许，则发送至法人手机" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30" v-if="!this.mchInfo.tempFilter.withoutBusiness">
                                        <el-col :span="c1">
                                            <el-form-item label="营业执照类型" prop="mchExtraInfo.businessType" :rules="rulesWithoutBusiness_mchExtraInfo_businessType" >
                                                <el-select v-model="mchInfo.mchExtraInfo.businessType" size="small" placeholder="营业执照类型" :disabled="this.mchInfo.tempFilter.withoutBusiness"
                                                           style="width: 100%;">
                                                    <el-option
                                                            v-for="item in _enums.BusinessTypeEnum"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="营业执照编号" prop="mchExtraInfo.businessLicense" :rules="rulesWithoutBusiness_mchExtraInfo_businessLicense" >
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.businessLicense" placeholder="营业执照编号"  :disabled="this.mchInfo.tempFilter.withoutBusiness" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="营业执照注册名称" prop="mchExtraInfo.businessName" :rules="rulesWithoutBusiness_mchExtraInfo_businessName" >
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.businessName" placeholder="营业执照注册名称" :disabled="this.mchInfo.tempFilter.withoutBusiness" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="c1">
                                            <el-form-item label="* 营业执照有效期">
                                    <span slot="label">* 营业执照有效期&nbsp;
                                        <el-checkbox v-model="mchInfo.tempFilter.businessExpDateNon" size="small" style="color: red;"><span style="font-weight:bold;font-size: 12px;">永久有效</span></el-checkbox>
                                    </span>
                                                <el-form-item prop='mchExtraInfo.businessForceDate' :rules="rulesWithoutBusiness_mchExtraInfo_businessForceDate">
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  style="width: auto" placeholder="生效期"
                                                                    v-model="mchInfo.mchExtraInfo.businessForceDate"
                                                                    :disabled="this.mchInfo.tempFilter.withoutBusiness" />
                                                </el-form-item>
                                                <el-form-item>&nbsp;-&nbsp;</el-form-item>
                                                <el-form-item prop='mchExtraInfo.businessExpDate' :rules="rulesRespIsLegal_mchExtraInfo_businessExpDate" >
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  style="width: auto" placeholder="有效期"
                                                                    v-model="mchInfo.mchExtraInfo.businessExpDate"
                                                                    :disabled="this.mchInfo.tempFilter.withoutBusiness || this.mchInfo.tempFilter.businessExpDateNon" />
                                                </el-form-item>
                                            </el-form-item>
                                        </el-col>

                                    </el-row>
                                    <el-row :gutter="30" v-if="this.mchInfo.mchExtraInfo.nature===this._enums.MchNatureEnum.企业.id">
                                        <el-col :span="c1">
                                            <el-form-item label="企业注册资本（万元）" prop="mchExtraInfo.businessRegCapitalBak" :rules="rulesWithoutBusiness_mchExtraInfo_businessRegCapital">
                                                <el-input size="small" v-model="mchInfo.mchExtraInfo.businessRegCapitalBak" placeholder="企业注册资本" @change="onRegCapitalChanged"
                                                          type="number" class="cls-input-number" :maxlength="6" oninput="if(value.length>6) value=value.slice(0,6)">
                                                    <span slot="suffix">万元</span>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <!--
                                    <el-row :gutter="30">
                                        <el-col :span="c1" v-if="!this.mchInfo.tempFilter.withoutBusiness">
                                            <el-form-item label="开户许可证" prop="mchExtraInfo.imgMchKhxkzUrl">
                                                <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgMchKhxkzUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgMchKhxkzUrl" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    -->
                                </div>

                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="结算账户" name="1"  v-if="showMchTab" >
                        <el-form :model="mchInfo.mchSettleInfo" ref="settSubFormRef" :rules="settSubFormRules">
                            <div class="tipTitle">结算账户</div>
                            <div class="form-s">
                                <el-row :gutter="30">
                                    <el-col :span="c1">
                                        <el-form-item label="账户类型" prop="settAccountType">
                                            <el-select v-model="mchInfo.mchSettleInfo.settAccountType" size="small" placeholder="账户类型"
                                                       style="width: 100%;">
                                                <el-option
                                                        v-for="item in this.mchInfo.mchExtraInfo.nature === this._enums.MchNatureEnum.小微商户.id ? _enums.SettleTypeEnum2 : _enums.SettleTypeEnum"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c3">
                                        <el-form-item label="开户银行" prop="settBankCode">
                                            <BankSelect :key="compBankSelectKey" v-bind:inCnapsCode="mchInfo.mchSettleInfo.settBankCode" v-bind:outCnapsCode.sync="mchInfo.mchSettleInfo.settBankCode" />                                </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="30">
                                    <el-col :span="c1">
                                        <el-form-item label="开户名称" prop="settAccountName">
                                            <el-input size="small" v-model="mchInfo.mchSettleInfo.settAccountName" placeholder="开户名称" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1">
                                        <el-form-item label="银行卡号" prop="settAccountNumber">
                                            <el-input size="small" v-model="mchInfo.mchSettleInfo.settAccountNumber" placeholder="银行卡号" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="开卡手机号" prop="settPhone">
                                            <el-input size="small" v-model="mchInfo.mchSettleInfo.settPhone" placeholder="开卡手机号" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="开卡身份证号" prop="settIdCardNo">
                                            <el-input size="small" v-model="mchInfo.mchSettleInfo.settIdCardNo" placeholder="开卡身份证号" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="结算人身份证有效期" prop="settIdCardExpDate" >
                                            <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  style="width: auto" placeholder="有效期"
                                                            v-model="mchInfo.mchSettleInfo.settIdCardExpDate" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="30">
                                    <el-col :span="c1" v-if="!this.mchInfo.tempFilter.withoutBusiness && mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.对公结算.id"> <!--  && !this.mchInfo.tempFilter.withoutBusinessOther -->
                                        <el-form-item label="开户许可证" prop="imgMchKhxkzUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchExtraInfo.imgMchKhxkzUrl" v-bind:outImgUrl.sync="mchInfo.mchExtraInfo.imgMchKhxkzUrl" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType !== this._enums.SettleTypeEnum.对公结算.id">
                                        <el-form-item label="结算卡正面照" prop="imgSettBankCardUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchSettleInfo.imgSettBankCardUrl" v-bind:outImgUrl.sync="mchInfo.mchSettleInfo.imgSettBankCardUrl" @onImgUpSuc="onImgUpSucBankCard" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType !== this._enums.SettleTypeEnum.对公结算.id">
                                        <el-form-item label="结算卡背面照" prop="imgSettBankCardBUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchSettleInfo.imgSettBankCardBUrl" v-bind:outImgUrl.sync="mchInfo.mchSettleInfo.imgSettBankCardBUrl" @onImgUpSuc="onImgUpSucBankCard" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="结算人身份证正面照" prop="imgSettIdCardFUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchSettleInfo.imgSettIdCardFUrl" v-bind:outImgUrl.sync="mchInfo.mchSettleInfo.imgSettIdCardFUrl" @onImgUpSuc="onImgUpSucNoLegalIdCard"/>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="结算人身份证反面照" prop="imgSettIdCardBUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchSettleInfo.imgSettIdCardBUrl" v-bind:outImgUrl.sync="mchInfo.mchSettleInfo.imgSettIdCardBUrl" @onImgUpSuc="onImgUpSucNoLegalIdCard" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="结算人手持身份证照" prop="imgSettIdCardHUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchSettleInfo.imgSettIdCardHUrl" v-bind:outImgUrl.sync="mchInfo.mchSettleInfo.imgSettIdCardHUrl" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1" v-if="mchInfo.mchSettleInfo.settAccountType === this._enums.SettleTypeEnum.非法人对私结算.id">
                                        <el-form-item label="非法人结算授权函照" prop="imgSettNonlegalAuthUrl">
                                            <ImgUpload :key="compImgUploadKey" v-if="img1Rest" v-bind:inImgUrl="mchInfo.mchSettleInfo.imgSettNonlegalAuthUrl" v-bind:outImgUrl.sync="mchInfo.mchSettleInfo.imgSettNonlegalAuthUrl" />
                                        </el-form-item>
                                    </el-col>


                                </el-row>

                            </div>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="产品和费率" name="2">
                        <!--  :model="tExtBlobsData" -->
                        <el-form ref="prodTempFormRef" :rules="prodTempFormRules">
                            <div class="tipTitle">产品选择</div>
                            <div class="form-s m-top--10">
                                <el-form-item label="" prop="tempProductCheck">
                                </el-form-item>
                                    <el-table :data="mchInfo.userProductList" v-loading="loading" size="mini" border
                                              :header-cell-style="{background:'#fafafa'}"
                                              @selection-change="handleSelectionChange"
                                              ref="prodTable">
                                        <el-table-column
                                                type="selection" align="center" width="55" v-if="this.inOptType==='INS' || this.inOptType==='ADD_PRD'"/>
                                        <el-table-column label="产品名称" width="150" align="center">
                                            <template slot-scope="scope">
                                                <el-tag type="warning" effect="dark" style="height: 25px">
                                                    <span style="font-size: 15px">{{scope.row.payProduct.productName}}</span>
                                                </el-tag>
                                                <span style="color: blue;font-weight: bolder" v-if="scope.row.payProduct.productCode==='XYF'"><br><i class="header-icon el-icon-info"></i>东北三省专用</span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column label="费率信息" prop="payProductChannelList" align="center" >
                                            <template slot-scope="scope">
                                                <el-table :data="scope.row.payProductChannelList" type="expand" :show-header="false">
                                                    <el-table-column width="150" align="center"
                                                                     label="交易方式">
                                                        <template slot-scope="scope">
                                                            {{scope.row.payName}}
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column label="费率" prop="userRateList" align="center">
                                                        <template slot-scope="scope">
                                                            <el-table :data="scope.row.userRateList" type="expand" :header-cell-style="{background:'#fafafa'}">
                                                                <el-table-column label="费率类型" prop="rateTypeDesc" />
                                                                <el-table-column label="费率（%）">
                                                                    <template slot-scope="scope">
                                                                        <span v-if="scope.row.rate===null">--</span>
                                                                        <el-input-number v-else :precision="2" :min="arch_miniRate[scope.row.id].rate"  :controls="false" v-model="scope.row.rate" :key="scope.row.id" />
                                                                    </template>
                                                                </el-table-column>
                                                                <el-table-column label="单笔固定（元）" >
                                                                    <template slot-scope="scope">
                                                                        <span v-if="scope.row.fixRate===null">--</span>
                                                                        <el-input-number v-else :precision="2" :min="arch_miniRate[scope.row.id].fixRate"  :controls="false" v-model="scope.row.fixRate" :key="scope.row.id" />
                                                                    </template>
                                                                </el-table-column>
                                                                <el-table-column label="单笔最低（元）">
                                                                    <template slot-scope="scope">
                                                                        <span v-if="scope.row.feeLowest===null">--</span>
                                                                        <el-input-number disabled v-else :precision="2" :min=arch_miniRate[scope.row.id].feeLowest :controls="false" v-model="scope.row.feeLowest" :key="scope.row.id" />
                                                                    </template>
                                                                </el-table-column>
                                                                <el-table-column label="单笔封顶（元）">
                                                                    <template slot-scope="scope">
                                                                        <span v-if="scope.row.feeHighest===null">--</span>
                                                                        <el-input-number v-else :precision="2" :min="arch_miniRate[scope.row.id].feeHighest" :controls="false" v-model="scope.row.feeHighest" :key="scope.row.id" />
                                                                    </template>
                                                                </el-table-column>
                                                            </el-table>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>




                                                <div class="tipTitle" style="display: flex; justify-content: left;">
                                                    <span style="font-weight:bold;font-size: 12px; color: red;">到账周期&nbsp;&nbsp;</span>
                                                    <el-switch v-model="scope.row.payProduct.settleCycle"
                                                               active-color="#ff0000" inactive-color="#13ce66" active-text="D0" inactive-text="D1"
                                                               :width="switchLen" :active-value="switchActive" :inactive-value="switchInactive"> </el-switch>
                                                    <span style="font-weight:normal;font-size: 12px; color: gray;">&nbsp;&nbsp;{{getProductDesc(scope.row.payProduct.productCode)}}</span>
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <!--
                                        -->


                                    </el-table>
                            </div>

                        </el-form>

                    </el-tab-pane>
                </el-tabs>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <div class="yx-flex-h-between">

                <div style="width: 90%; margin-left: -12%;">
                    <!--
                    stepTab-0 将String转为Number
                    原因：el-steps active绑定的为number类型。el-tabs v-model绑定的为String类型。为使step和tab翻页同步，将两个组件绑定同一个变量。
                    -->
                    <el-steps class="cls-step" :active="stepTab-0" finish-status="success" align-center	>
                        <el-step title="商户信息"></el-step>
                        <el-step title="结算账户"></el-step>
                        <el-step title="产品和费率"></el-step>
                    </el-steps>
                </div>
                <div class="yx-flex-h-start">
                    <!--
                    <el-button size="small" type="success" @click="readTemp">读存</el-button>
                    <el-button size="small" type="success" @click="saveTemp">暂存</el-button>
                    -->
                    <el-button size="small" icon="el-icon-arrow-left" type="success" v-if="stepTab!==MIN_TAB_IDX && showMchTab" @click="stepPre">上一步</el-button>
                    <el-button size="small" type="success" v-if="stepTab!==MAX_TAB_IDX" @click="stepNext">下一步<i class="el-icon-arrow-right el-icon--right"/></el-button>
                    <div v-if="stepTab===MAX_TAB_IDX" style="margin-left:8px;">
                        <el-button v-if="!putting" size="small" icon="el-icon-upload2" type="primary" @click="stepNext">&nbsp;&nbsp;提&nbsp;&nbsp;交</el-button>
                        <el-tag v-else type="danger" size="medium" effect="light" disable-transitions style="font-weight: bolder">
                            <i class="el-icon-loading" /><span >&nbsp;&nbsp;提交中&nbsp;&nbsp;</span>
                        </el-tag>
                        <!--
                        <el-button v-if="!putting" size="small" icon="el-icon-upload2" type="primary" @click="handleMainDlgOkClick">&nbsp;&nbsp;提&nbsp;&nbsp;交</el-button>
                        <el-button v-else disabled size="small" icon="el-icon-loading" type="primary" >提交中</el-button>
                        -->
                    </div>
                </div>
            </div>

            <!--
            <el-button size="small" @click="showDlg = false">取 消</el-button>
            -->
        </span>
        <!-- IP IP
        <remote-js src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-js>
        -->
    </el-dialog>
</template>

<script>
    import ImgUpload from "../pub/ImgUpload";
    import AreaSelect from "../pub/AreaSelect";
    import BankSelect from "../pub/BankSelect";
    import { URL_DATA_MCH_BUSINESSCATEGORY} from "../../utils/cons";
    import { URL_IMG_OCR_BIZ, URL_IMG_OCR_BANK_CARD, URL_IMG_OCR_ID_CARD} from "../../utils/cons";
    import {deepClone, findIdxByKeyValue} from "../../utils/datatool";
    import {MiniRate} from "../../utils/MiniRate";
    export default {
        name: "MchBaseDlg",
        props:["inOptType", "inMchInfo"],
        components: {ImgUpload, AreaSelect, BankSelect,
            'remote-js': { // 搜狐接口获取本地外网IP
                render(createElement) {
                    return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
                },
                props: {
                    src: { type: String, required: true },
                },
            }
        },
        computed: {
            getSettleCycle () {
                return function (productCode) {
                    console.log("getSettleCycle->" + productCode, this.tExtBlobsData.find(item => item.productCode === productCode))
                    return this.tExtBlobsData.find(item => item.productCode === productCode) ? 1 : 2
                }
            },
            rulesRespIsLegal_mchExtraInfo_responsibleName:function(){return !this.mchInfo.tempFilter.respIsLegal?[{required: true, message: '请输入负责人姓名', trigger: 'blur'}]:[];},
            rulesRespIsLegal_mchExtraInfo_responsiblePhone:function(){return !this.mchInfo.tempFilter.respIsLegal?[{required: true, message: '请输入负责人电话', trigger: 'blur'}]:[];},
            rulesRespIsLegal_mchExtraInfo_responsibleIdCardNo:function(){return !this.mchInfo.tempFilter.respIsLegal?[{required: true, message: '请输入负责人证件号', trigger: 'blur'}]:[];},
            rulesRespIsLegal_mchExtraInfo_legalIdCardExpDate:function(){return !this.mchInfo.tempFilter.legalIdExpDateNon?[{required: true, message: '请选择法人证件有效期', trigger: 'blur'}]:[];},

            rulesRespIsLegal_mchExtraInfo_businessExpDate:function(){return (!this.mchInfo.tempFilter.businessExpDateNon && !this.mchInfo.tempFilter.withoutBusiness)?[{required: true, message: '请选择营业执照有效期', trigger: 'blur'}]:[];},

            rulesWithoutBusiness_mchExtraInfo_businessLicense:function(){return !this.mchInfo.tempFilter.withoutBusiness?[{required: true, message: '请输入营业执照编号', trigger: 'blur'}]:[];},
            rulesWithoutBusiness_mchExtraInfo_businessName:function(){return !this.mchInfo.tempFilter.withoutBusiness?[{required: true, message: '请输入营业执照注册名称', trigger: 'blur'}]:[];},
            rulesWithoutBusiness_mchExtraInfo_businessRegCapital:function(){return (!this.mchInfo.tempFilter.withoutBusiness && this.mchInfo.mchExtraInfo.nature===this._enums.MchNatureEnum.企业.id)?[{required: true, message: '请输入注册资本', trigger: 'blur'}]:[];},
            rulesWithoutBusiness_mchExtraInfo_businessType:function(){return !this.mchInfo.tempFilter.withoutBusiness?[{required: true, message: '请选择营业执照类型', trigger: 'blur'}]:[];},
            rulesWithoutBusiness_mchExtraInfo_businessForceDate:function(){return !this.mchInfo.tempFilter.withoutBusiness?[{required: true, message: '请选择营业执照有效期', trigger: 'blur'}]:[];},

        },
        watch: {

        },
        data() {
            let checkAreas=(rule, value, callback) => {
                if (value) {
                    if(value.provId===null || value.provId.length===0) callback(new Error('请选择省份'));
                    else if(value.cityId===null || value.cityId.length===0) callback(new Error('请选择城市'));
                    else if(value.distId===null || value.distId.length===0) callback(new Error('请选择区县'));
                    else callback();
                }
                else callback(new Error('请选择区域'));
            };
            let checkProduct=(rule, value, callback) => {
                let selectRowProductCodeArr = this.getSelectRowProductCodeArr();
                if(selectRowProductCodeArr.length===0) {
                    callback(new Error('请选择支付产品!'));
                } else {
                    callback();
                }
            };
            return {
                putting: false,
                switchLen: 50,
                switchActive: 1,
                switchInactive: 2,
                multipleSelection: [],
                disableBtn: false,
                showMchTab : true,
                stepTab: '0',
                MIN_TAB_IDX: '0',
                MAX_TAB_IDX: '2',
                loading: false,
                slChecked: false,
                jhChecked: false,
                title: null,
                showDlg: false,
                c0: 3,
                c1: 6,
                c2: 12,
                c3: 18,
                c4: 24,
                img1Rest: true,
                enum_mchExtraInfoBusinessId: null,
                arch_userBaseProductRateInfo: null,
                arch_miniRate: null,
                tempProductCheck: null,
                /**
                tmpProdInfo: {
                    // tempProductCheck: null,
                    jhExt: { productCode:'JH',productName:'聚合产品', status: 0, payChannelCode:'KDB', settCycle:2,
                        imgReceiptAgreementUrl: null,
                        imgMchUpdateUrl: null,
                        imgSettNonlegalAuthUrl: null,
                        imgMchZcdjbUrl: null },
                    slExt: { productCode:'SL',productName:'刷脸产品', status: 0, payChannelCode:'SXF', settCycle:2,
                        imgReceiptAgreementUrl: null,
                        imgMchUpdateUrl: null,
                        imgSettNonlegalAuthUrl: null,
                        imgMchZcdjbUrl: null },
                    slExtC: { productCode:'SLC',productName:'刷脸产品C', status: 0, payChannelCode:'XYF', settCycle:2,
                        imgReceiptAgreementUrl: null,
                        imgMchUpdateUrl: null,
                        imgSettNonlegalAuthUrl: null,
                        imgMchZcdjbUrl: null },
                    qrExt: { productCode:'QR',productName:'聚合支付', status: 0, payChannelCode:'YSF', settCycle: 2,
                        imgReceiptAgreementUrl: null,
                        imgMchUpdateUrl: null,
                        imgSettNonlegalAuthUrl: null,
                        imgMchZcdjbUrl: null },
                    qrExt: { productCode:'LKL',productName:'拉卡拉', status: 0, payChannelCode:'LKL', settCycle: 2,
                        imgReceiptAgreementUrl: null,
                        imgMchUpdateUrl: null,
                        imgSettNonlegalAuthUrl: null,
                        imgMchZcdjbUrl: null },
                },
                */
                tExtBlobsData: [],
                businessArr:[],
                ysfRateTemplate: 0.36,
                compAreaKey: null,
                compImgUploadKey: null,
                compBankSelectKey: null,
                loadFinish: false,
                mchInfo: {
                    id: null,
                    type: null,
                    status: null,
                    mchNo: null,
                    mchName: null,
                    shortName: null,
                    salesmanId: null,
                    salesmanName: null,
                    outMchNo: null,
                    createWay: null,
                    createIp: null,
                    remark: null,
                    userProductList: [], // 产品信息列表
                    mchExtraChannelInfoWithBLOBsList: [], // 渠道扩展信息列表
                    mchExtraInfo: {
                        id: null,
                        type: null,
                        status: null,
                        mchId: null,
                        nature: null,
                        companyType: null,
                        businessId: null,
                        servicePhone: null,
                        adsProvinceCode: null,
                        adsCityCode: null,
                        adsAreaCode: null,
                        adsAddress: null,
                        adsType: null,
                        adsLongitude: null,
                        adsLatitude: null,
                        adsGeoAddress: null,
                        legalName: null,
                        legalSex: null,
                        legalPhone: null,
                        legalIdCardNo: null,
                        legalIdCardForceDate: null,
                        legalIdCardExpDate: null,
                        businessLicense: null,
                        businessName: null,
                        businessType: null,
                        businessRegCapital: null,
                        businessRegCapitalBak: null,
                        businessForceDate: null,
                        businessExpDate: null,
                        responsibleName: null,
                        responsiblePhone: null,
                        responsibleEmail: null,
                        responsibleIdCardNo: null,
                        imgLegalIdCardF: null,imgLegalIdCardFUrl: null,
                        imgLegalIdCardB: null,imgLegalIdCardBUrl: null,
                        imgLegalIdCardH: null,imgLegalIdCardHUrl: null,
                        imgBusinessF: null,imgBusinessFUrl: null,
                        imgMchKhxkz: null,imgMchKhxkzUrl: null,
//                        imgMchZcdjb: null,imgMchZcdjbUrl: null,
                        imgShopOutside: null,imgShopOutsideUrl: null,
                        imgShopInside: null,imgShopInsideUrl: null,
                        imgShopCashRegister: null,imgShopCashRegisterUrl: null,
                        imgShopGoods: null,imgShopGoodsUrl: null,
                        imgOther1: null,imgOther1Url: null,
                        imgOther2: null,imgOther2Url: null,
                        imgOther3: null,imgOther3Url: null,
                        imgOther4: null,imgOther4Url: null,
                        imgOther5: null,imgOther5Url: null,
                        remark: null,
                        tempAreas: {
                            provId: null, cityId: null, distId: null
                        },
                    },
                    mchSettleInfo: {
                        id: null,
                        type: null,
                        status: null,
                        mchId: null,
                        settAccountType: null,
                        settBankCode: null,
                        settCityName: null,
                        settBankName: null,
                        settBranchName: null,
                        settAccountName: null,
                        settAccountNumber: null,
                        settIdCardNo: null,
                        settIdCardExpDate: null,
                        settPhone: null,
                        imgSettNonlegalAuth: null,imgSettNonlegalAuthUrl: null,
                        imgSettBankCard: null,imgSettBankCardUrl: null,
                        imgSettBankCardB: null,imgSettBankCardBUrl: null,
                        imgSettIdCardF: null,imgSettIdCardFUrl: null,
                        imgSettIdCardB: null,imgSettIdCardBUrl: null,
                        imgSettIdCardH: null,imgSettIdCardHUrl: null,
                        remark: null
                    },
                    tempFilter: {
                        respIsLegal: false, // 负责人同法人
                        legalIdExpDateNon: false, // 法人身份证永久有效
                        businessExpDateNon: false, // 营业执照永久有效
                        withoutBusiness: false, // 不需要营业执照相关信息
                        withoutBusinessOther: false, // 三证合一，不需要营业执照以外的开户许可证等信息
                        withoutSettleToNoLegal: false, // 不是非法人对私结算，不需要授权书等信息
                    },
                },
                prodTempFormRules: {
                    'tempProductCheck' : [{required: true, trigger: 'blur', validator:checkProduct}],

                    'jhExt.imgReceiptAgreementUrl' : [{required: true, message: '请选择聚合协议照片', trigger: 'blur'}],
                    'jhExt.imgMchUpdateUrl' : [{required: true, message: '请选择聚合变更登记表', trigger: 'blur'}],
                    'jhExt.imgSettNonlegalAuthUrl' : [{required: true, message: '请选择聚合非法人结算授权函', trigger: 'blur'}],
                    'jhExt.imgMchZcdjbUrl' : [{required: true, message: '请选择聚合收单注册登记表', trigger: 'blur'}],

                    'slExt.imgReceiptAgreementUrl' : [{required: true, message: '请选择刷脸协议照片', trigger: 'blur'}],
                    'slExt.imgMchUpdateUrl' : [{required: true, message: '请选择刷脸变更登记表', trigger: 'blur'}],
                    'slExt.imgSettNonlegalAuthUrl' : [{required: true, message: '请选择刷脸非法人结算授权函', trigger: 'blur'}],

                    'slExtC.imgReceiptAgreementUrl' : [{required: true, message: '请选择刷脸协议照片', trigger: 'blur'}],
                    'slExtC.imgMchUpdateUrl' : [{required: true, message: '请选择刷脸变更登记表', trigger: 'blur'}],
                    'slExtC.imgSettNonlegalAuthUrl' : [{required: true, message: '请选择刷脸非法人结算授权函', trigger: 'blur'}],

                    'qrExt.imgReceiptAgreementUrl' : [{required: true, message: '请选择支付码协议照片', trigger: 'blur'}],
                    'qrExt.imgMchUpdateUrl' : [{required: true, message: '请选择支付码变更登记表', trigger: 'blur'}],
                    'qrExt.imgSettNonlegalAuthUrl' : [{required: true, message: '请选择支付码非法人结算授权函', trigger: 'blur'}],

                },
                settSubFormRules: {
                    // 'imgMchKhxkzUrl' : [{required: true, message: '请选择开户许可证', trigger: 'blur'}],
                    'mchExtraInfo.imgMchKhxkzUrl' : [{required: true, message: '请选择开户许可证', trigger: 'blur'}],
                    'settAccountType' : [{required: true, message: '请选择账户类型', trigger: 'blur'}],
                    'settBankCode' : [{required: true, message: '请选择开户银行', trigger: 'blur'}],
                    'settAccountName' : [{required: true, message: '请输入开户名称', trigger: 'blur'}],
                    'settAccountNumber' : [{required: true, message: '请输入银行卡号', trigger: 'blur'}],
                    'settPhone' : [{required: true, message: '请输入开卡手机号', trigger: 'blur'}],
                    'settIdCardNo' : [{required: true, message: '请输入开卡身份证号', trigger: 'blur'}],
                    'settIdCardExpDate' : [{required: true, message: '请选择结算人身份证有效期', trigger: 'blur'}],
                    'imgSettBankCardUrl' : [{required: true, message: '请选择结算卡正面照', trigger: 'blur'}],
                    'imgSettBankCardBUrl' : [{required: true, message: '请选择结算卡背面照', trigger: 'blur'}],
                    'imgSettIdCardFUrl' : [{required: true, message: '请选择结算人身份证正面照', trigger: 'blur'}],
                    'imgSettIdCardBUrl' : [{required: true, message: '请选择结算人身份证反面照', trigger: 'blur'}],
                    'imgSettIdCardHUrl' : [{required: true, message: '请选择结算人手持身份证照', trigger: 'blur'}],
                    'imgSettNonlegalAuthUrl' : [{required: true, message: '请选择非法人结算授权函照', trigger: 'blur'}]
                },
                baseMainFormRules: {
                    'mchName' : [{required: true, message: '请输入商户名称', trigger: 'blur'}],
                    'shortName' : [{required: true, message: '请输入商户简称', trigger: 'blur'}],
                    'mchExtraInfo.businessId' : [{required: true, message: '请选择经营类目', trigger: 'blur'}],
                    'mchExtraInfo.nature' : [{required: true, message: '请选择商户性质', trigger: 'blur'}],
                    'mchExtraInfo.companyType' : [{required: true, message: '请选择公司类型', trigger: 'blur'}],
                    'mchExtraInfo.tempAreas' : [{required: true, trigger: 'blur', validator:checkAreas}],
                    'mchExtraInfo.adsAddress' : [{required: true, message: '请输入详细地址', trigger: 'blur'}],
                    'mchExtraInfo.responsibleEmail' : [{required: true, message: '请输入联系邮箱', trigger: 'blur'}],
                    'mchExtraInfo.servicePhone' : [{required: true, message: '请输入客服电话', trigger: 'blur'}],
                    'mchExtraInfo.legalName' : [{required: true, message: '请输入法人姓名', trigger: 'blur'}],
                    'mchExtraInfo.legalPhone' : [{required: true, message: '请输入法人电话', trigger: 'blur'}],
                    'mchExtraInfo.legalIdCardNo' : [{required: true, message: '请输入法人身份证号', trigger: 'blur'}],
                    'mchExtraInfo.legalIdCardForceDate' : [{required: true, message: '请选择法人证件生效期', trigger: 'blur'}],
                    'mchExtraInfo.imgBusinessFUrl' : [{required: true, message: '请选择营业执照图片', trigger: 'blur'}],
                    'mchExtraInfo.imgLegalIdCardFUrl' : [{required: true, message: '请选择法人证件正面照', trigger: 'blur'}],
                    'mchExtraInfo.imgLegalIdCardBUrl' : [{required: true, message: '请选择法人证件反面照', trigger: 'blur'}],
                    'mchExtraInfo.imgLegalIdCardHUrl' : [{required: true, message: '请选择法人手持证件正面照', trigger: 'blur'}],
                    // 'mchExtraInfo.imgMchKhxkzUrl' : [{required: true, message: '请选择开户许可证', trigger: 'blur'}],
                    'mchExtraInfo.imgShopOutsideUrl' : [{required: true, message: '请选择门店店面照', trigger: 'blur'}],
                    'mchExtraInfo.imgShopInsideUrl' : [{required: true, message: '请选择门店店内照', trigger: 'blur'}],
                    'mchExtraInfo.imgShopCashRegisterUrl' : [{required: true, message: '请选择门店收银台照', trigger: 'blur'}],
                    'mchExtraInfo.imgShopGoodsUrl' : [{required: true, message: '请选择门店商品照', trigger: 'blur'}],
                    'mchSettleInfo.settAccountType' : [{required: true, message: '请选择账户类型', trigger: 'blur'}],
                    'mchSettleInfo.settBankCode' : [{required: true, message: '请选择开户银行', trigger: 'blur'}],
                    'mchSettleInfo.settAccountName' : [{required: true, message: '请输入开户名称', trigger: 'blur'}],
                    'mchSettleInfo.settAccountNumber' : [{required: true, message: '请输入银行卡号', trigger: 'blur'}],
                    'mchSettleInfo.settPhone' : [{required: true, message: '请输入开卡手机号', trigger: 'blur'}],
                    'mchSettleInfo.settIdCardNo' : [{required: true, message: '请输入开卡身份证号', trigger: 'blur'}],
                    'mchSettleInfo.settIdCardExpDate' : [{required: true, message: '请选择结算人身份证有效期', trigger: 'blur'}],
                    'mchSettleInfo.imgSettBankCardUrl' : [{required: true, message: '请选择结算卡正面照', trigger: 'blur'}],
                    'mchSettleInfo.imgSettBankCardBUrl' : [{required: true, message: '请选择结算卡背面照', trigger: 'blur'}],
                    'mchSettleInfo.imgSettIdCardFUrl' : [{required: true, message: '请选择结算人身份证正面照', trigger: 'blur'}],
                    'mchSettleInfo.imgSettIdCardBUrl' : [{required: true, message: '请选择结算人身份证反面照', trigger: 'blur'}],
                    'mchSettleInfo.imgSettIdCardHUrl' : [{required: true, message: '请选择结算人手持身份证照', trigger: 'blur'}]
                },
                hasBaseMchStore: false,
            };
        },
        //////////////////////////////////////////////////////////////////////
        // 组件初始化加载
        //////////////////////////////////////////////////////////////////////
        mounted() {
            /**
             * 产品费率有很多相关的验证和回调，所以必须要等 成本费率加载完成，才能继续下一步。否则退出。
             * 目前，放在全局加载，以加快页面速度。但是，如果成本费率做了调整，需要刷新或重新登录。
             *
             * */
            this.hasBaseMchStore = localStorage.hasOwnProperty('mch-base-form');
            if(!this.$root.g_data_user_product_rate) {
                this.$message.error("成本费率未加载，请刷新页面!");
                this.showDlg = false;
            }
            if(!this.$root.g_data_business_category) {
                this.$message.error("行业基础信息未加载，请刷新页面!");
                this.showDlg = false;
            }
            this.enum_mchExtraInfoBusinessId = this.$root.g_data_business_category;
            this.arch_userBaseProductRateInfo = this.$root.g_data_user_product_rate;

            this.initChannelConfig()

            switch (this.inOptType) {
                case 'INS':
                    this.title = '商户进件';
                    this.arch_miniRate = this.$root.g_data_mini_rate; // 新进件的费率ID为成本费率的ID
                    break;
                case 'UPD_EXT':
                case 'UPD':
                    this.inOptType==='UPD_EXT'?this.title = '补充商户信息':this.title = '更新商户信息';

                    this.arch_miniRate = new MiniRate();
                    for(let iii=0; iii<this.inMchInfo.userProductList.length; iii++) {
                        for(let jjj=0; jjj<this.inMchInfo.userProductList[iii].payProductChannelList.length; jjj++) {
                            for(let kkk=0; kkk<this.inMchInfo.userProductList[iii].payProductChannelList[jjj].userRateList.length; kkk++) {
                                let userRate = this.inMchInfo.userProductList[iii].payProductChannelList[jjj].userRateList[kkk];
                                let gMiniRate = this.$root.g_data_mini_rate[userRate.payChannelCode+'-'+userRate.payWayCode+'-'+userRate.payModeCode+'-'+userRate.rateType];
                                // 需要判断gMiniRate是否为null,可能存在一种情况？给商户设置的某条费率信息，在代理商的费率信息里找不到。。。 应该不会。代理商不会删除，可能新增。增量的话，代理商永远包含商户费率信息。
                                // 用费率4要素，去代理商成本费率匹配到最低费率。存在新的最低费率档案里。
                                // 因为最低费率档案，是用ID做索引的，所以新增 和 修改 是有区别的。新增的ID是固定的取成本费率的ID。修改的，每个商户的费率ID都不用，所以需要重组一次最低费率档案。
                                this.arch_miniRate.add(userRate.id, gMiniRate.rate, gMiniRate.fixRate, gMiniRate.feeLowest, gMiniRate.feeHighest,
                                    userRate.payChannelCode, userRate.payWayCode, userRate.payModeCode, userRate.rateType);
                            }
                        }
                    }

                    this.mchInfo = this.inMchInfo;
                    this.initFormBef();
                    break;
                case 'ADD_PRD':
                    this.title = '增加产品';
                    this.showMchTab = false;
                    this.stepTab = this.MAX_TAB_IDX;

                    this.arch_miniRate = new MiniRate();
                    for(let iii=0; iii<this.inMchInfo.userProductList.length; iii++) {
                        for(let jjj=0; jjj<this.inMchInfo.userProductList[iii].payProductChannelList.length; jjj++) {
                            for(let kkk=0; kkk<this.inMchInfo.userProductList[iii].payProductChannelList[jjj].userRateList.length; kkk++) {
                                let userRate = this.inMchInfo.userProductList[iii].payProductChannelList[jjj].userRateList[kkk];
                                let gMiniRate = this.$root.g_data_mini_rate[userRate.payChannelCode+'-'+userRate.payWayCode+'-'+userRate.payModeCode+'-'+userRate.rateType];
                                // 需要判断gMiniRate是否为null,可能存在一种情况？给商户设置的某条费率信息，在代理商的费率信息里找不到。。。 应该不会。代理商不会删除，可能新增。增量的话，代理商永远包含商户费率信息。
                                // 用费率4要素，去代理商成本费率匹配到最低费率。存在新的最低费率档案里。
                                // 因为最低费率档案，是用ID做索引的，所以新增 和 修改 是有区别的。新增的ID是固定的取成本费率的ID。修改的，每个商户的费率ID都不用，所以需要重组一次最低费率档案。
                                this.arch_miniRate.add(userRate.id, gMiniRate.rate, gMiniRate.fixRate, gMiniRate.feeLowest, gMiniRate.feeHighest,
                                    userRate.payChannelCode, userRate.payWayCode, userRate.payModeCode, userRate.rateType);
                            }
                        }
                    }

                    this.mchInfo = this.inMchInfo;
                    this.initFormBef();
                    /**
                     * 不好的处理，可以选择隐藏一行，暂时没找到方法，直接弹出数组
                     */
                    this.mchInfo.userProductList.forEach( (item, index) => {
                        if(item.status===1) {
                            this.mchInfo.userProductList.splice(index, 1);
                        }
                    });
                    this.mchInfo.mchExtraChannelInfoWithBLOBsList.forEach( (item, index) => {
                        if(1===1) {
                            this.mchInfo.mchExtraChannelInfoWithBLOBsList.splice(index, 1);
                        }
                    });
                    break;
                default:
                    return;
            }

            this.showDlg = true;

            this.watchChangeHandler();

        },
        methods: {
            setSettleCycle (productCode) {

                this.mchInfo.mchExtraChannelInfoWithBLOBsList.forEach(item => {
                    if (item.productCode === productCode) {
                        item.settCycle = item.settCycle === 1 ? 2 : 1
                        // console.log("item.settCycle", item.settCycle)
                    }
                })
            },
            getProductDesc (productCode) {
                // console.log(productCode, this.tExtBlobsData)
                let prod = this.tExtBlobsData.find(item => item.productCode === productCode)
                if (prod) return prod.productDesc
                // console.log("prod", this.tExtBlobsData)
            },
            // 初始化prodChannelData所有产品渠道信息数组
            initChannelConfig () {
                this.tExtBlobsData = []
                let prodChannelArr = this._enums.ProductChannelEnum.toProdChannelArr()
                prodChannelArr.forEach(item => {
                    this.tExtBlobsData.push({
                            productCode: item.productCode,
                            payChannelCode: item.payChannelCode,
                            status: 0, // 未选
                            settCycle: 2, // 1-D0 2-D1
                            productDesc: item.productDesc,
                            imgReceiptAgreementUrl: null, // 收单协议表
                            imgMchUpdateUrl: null, // 变更协议表
                            imgSettNonlegalAuthUrl: null, // 非法人授权表
                            imgMchZcdjbUrl: null // 注册登记表
                        }
                    )
                })
            },
            onImgUpSucBiz (imgUrl) {
                let url = URL_IMG_OCR_BIZ + '?url=' + imgUrl;
                this.getRequest(url).then(resp => {
                    if (resp && resp.obj) {
                        let data = resp.obj
                        this.mchInfo.mchName = data.name
                        this.mchInfo.shortName = data.name
                        this.mchInfo.mchExtraInfo.legalName = data.person
                        this.mchInfo.mchExtraInfo.businessName = data.name
                        this.mchInfo.mchExtraInfo.businessLicense = data.regNum
                        this.mchInfo.mchExtraInfo.adsAddress = data.address
                        if (data.type) {
                            if (data.type.length >= 6 && data.type.substring(0,6) === "有限责任公司") {
                                this.mchInfo.mchExtraInfo.companyType = this._enums.CompanyTypeEnum.有限责任公司.id
                            } else if (data.type.length >= 5 && data.type.substring(0,5) === "个体工商户") {
                                this.mchInfo.mchExtraInfo.companyType = this._enums.CompanyTypeEnum.个体.id
                            } else {
                                this.mchInfo.mchExtraInfo.companyType = this._enums.CompanyTypeEnum.getIdByName(data.type)
                            }
                        }
                        this.mchInfo.mchExtraInfo.businessRegCapitalBak = data.capital.replace(/[^0-9.]/g,"")
                        let tmp = data.period.replace(/年/g,"-").replace(/月/g,"-").replace(/日/g,"")
                        let arr = tmp.split("至")
                        if (Array.isArray(arr) && arr.length === 2) {
                            let dateBeg = arr[0]
                            let dateEnd = arr[1]
                            console.log(dateBeg, dateEnd)
                            if (dateEnd === "长期") {
                                this.mchInfo.tempFilter.businessExpDateNon = true
                            } else {
                                this.mchInfo.tempFilter.businessExpDateNon = false
                                this.mchInfo.mchExtraInfo.businessExpDate = dateEnd
                            }
                            this.mchInfo.mchExtraInfo.businessForceDate = dateBeg
                        }
                    }
                })
            },
            onImgUpSucIdCard (imgUrl) {
                let url = URL_IMG_OCR_ID_CARD + '?url=' + imgUrl;
                this.getRequest(url).then(resp => {
                    if (resp && resp.obj) {
                        let data = resp.obj
                        if (data.idNum && data.idNum.length === 18) {
                            this.mchInfo.mchExtraInfo.legalName = data.name
                            this.mchInfo.mchExtraInfo.legalIdCardNo = data.idNum
                        } else {
                            let tmp = data.validDate.replace("-","|")
                            tmp = tmp.replace(/\./g,"-")
                            let arr = tmp.split("|")
                            if (Array.isArray(arr) && arr.length === 2) {
                                let dateBeg = arr[0]
                                let dateEnd = arr[1]
                                console.log(dateBeg, dateEnd)
                                if (dateEnd === "长期") {
                                    this.mchInfo.tempFilter.legalIdExpDateNon = true
                                } else {
                                    this.mchInfo.tempFilter.legalIdExpDateNon = false
                                    this.mchInfo.mchExtraInfo.legalIdCardExpDate = dateEnd
                                }
                                this.mchInfo.mchExtraInfo.legalIdCardForceDate = dateBeg
                            }
                        }
                    }
                })
            },
            onImgUpSucBankCard (imgUrl) {
                let url = URL_IMG_OCR_BANK_CARD + '?url=' + imgUrl;
                this.getRequest(url).then(resp => {
                    if (resp && resp.obj) {
                        let data = resp.obj
                        if (data.cardNo && data.cardNo.length>6) {
                            this.mchInfo.mchSettleInfo.settAccountNumber = data.cardNo
                        }
                    }
                })
            },
            onImgUpSucNoLegalIdCard (imgUrl) {
                let url = URL_IMG_OCR_ID_CARD + '?url=' + imgUrl;
                this.getRequest(url).then(resp => {
                    if (resp && resp.obj) {
                        let data = resp.obj
                        if (data.idNum && data.idNum.length === 18) {
                            this.mchInfo.mchSettleInfo.settAccountName = data.name
                            this.mchInfo.mchSettleInfo.settIdCardNo = data.idNum
                        } else {
                            let tmp = data.validDate.replace("-","|")
                            tmp = tmp.replace(/\./g,"-")
                            let arr = tmp.split("|")
                            if (Array.isArray(arr) && arr.length === 2) {
                                let dateBeg = arr[0]
                                let dateEnd = arr[1]
                                console.log(dateBeg, dateEnd)
                                if (dateEnd === "长期") {
                                    this.mchInfo.mchSettleInfo.settIdCardExpDate = "2099-12-31"
                                } else {
                                    this.mchInfo.mchSettleInfo.settIdCardExpDate = dateEnd
                                }
                            }
                        }
                    }
                })
            },
            // hasMchBaseStorage:function(){return localStorage.hasOwnProperty('mch-base-form');},
            onRegCapitalChanged() {
                this.mchInfo.mchExtraInfo.businessRegCapital = 10000*this.mchInfo.mchExtraInfo.businessRegCapitalBak;
                console.log("补充 - 商户扩展信息 - 注册资本", this.mchInfo.mchExtraInfo.businessRegCapitalBak+"万元", this.mchInfo.mchExtraInfo.businessRegCapital+"元")
            },
            onBusinessChanged(val) {
                console.log("补充 - 商户扩展信息 - 从商户行业级联数据中获取末级value（businessId，MCC使用）", JSON.stringify(val));
                if (val.length===3) {
                    this.mchInfo.mchExtraInfo.businessId = val[2]
                }
            },
            onAreasChanged(areas) {
                console.log("补充 - 商户扩展信息 - 从区域组件获取省市区代码", JSON.stringify(areas));
                this.mchInfo.mchExtraInfo.tempAreas.provId = areas.provId;
                this.mchInfo.mchExtraInfo.tempAreas.cityId = areas.cityId;
                this.mchInfo.mchExtraInfo.tempAreas.distId = areas.distId;
                this.mchInfo.mchExtraInfo.adsProvinceCode = areas.provId;
                this.mchInfo.mchExtraInfo.adsCityCode = areas.cityId;
                this.mchInfo.mchExtraInfo.adsAreaCode = areas.distId;

            },
            onYsfRateTemplateChanged() {
                /**
                console.log("补充 - 商户产品&渠道信息 - 0普通费率-全部遍历设置为指定费率", this.ysfRateTemplate);
                for (let i=0;i<this.mchInfo.userProductList.length;i++) {
                    for (let j=0;j<this.mchInfo.userProductList[i].payProductChannelList.length;j++) {
                        for(let k=0;k<this.mchInfo.userProductList[i].payProductChannelList[j].userRateList.length;k++) {
                            if (this.mchInfo.userProductList[i].payProductChannelList[j].userRateList[k].rateType===0) {
                                this.mchInfo.userProductList[i].payProductChannelList[j].userRateList[k].rate = this.ysfRateTemplate
                            }
                        }
                    }
                }
                */
            },
            watchChangeHandler() {
                // this.$watch('mchInfo.tempFilter.withoutBusiness', this.testHandler);

                this.$watch('mchInfo.tempFilter.legalIdExpDateNon', this.legalIdExpDateNonChangeHandler);
                this.$watch('mchInfo.tempFilter.businessExpDateNon', this.businessExpDateNonChangeHandler);
                this.$watch('mchInfo.tempFilter.respIsLegal', this.respIsLegalChangeHandler);
                this.$watch('mchInfo.mchExtraInfo.nature', this.natureChangeHandler);
                this.$watch('mchInfo.mchExtraInfo.businessType', this.businessTypeChangeHandler);
                this.$watch('mchInfo.mchExtraInfo.companyType', this.companyTypeChangeHandler);
                this.$watch('mchInfo.mchSettleInfo.settAccountType', this.settAccountTypeChangeHandler);
                this.$watch('mchInfo.mchSettleInfo.settBankCode', this.settBankCodeChangeHandler);
                this.$watch('mchInfo.mchExtraInfo.tempAreas.distId', this.distIdChangeHandler);
                this.$watch('businessArr', this.businessArrChangeHandler);

                setTimeout(() =>{
                    this.natureChangeHandler(this.mchInfo.mchExtraInfo.nature,null);
                    this.businessTypeChangeHandler(this.mchInfo.mchExtraInfo.businessType,null);
                    this.settAccountTypeChangeHandler(this.mchInfo.mchSettleInfo.settAccountType,null);
                    this.loadFinish = true
                },500);
            },
            natureChangeHandler(valNew, valOld) {
                this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.nature');
                if(this.mchInfo.tempFilter.businessExpDateNon) this.mchInfo.mchExtraInfo.businessExpDate='2099-12-31';
                // this.mchInfo.mchExtraInfo.companyType = null
                switch (valNew) {
                    case this._enums.MchNatureEnum.个体工商户.id:
                        this.mchInfo.tempFilter.withoutBusiness = false;
                        this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessRegCapitalBak');
                        break;
                    case this._enums.MchNatureEnum.小微商户.id:
                        this.mchInfo.tempFilter.withoutBusiness = true;
                        this.mchInfo.mchExtraInfo.companyType = this._enums.CompanyTypeEnum.个体.id
                        if(this.mchInfo.tempFilter.businessExpDateNon) this.mchInfo.mchExtraInfo.businessExpDate='';
                        this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessType');
                        this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessName');
                        this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessLicense');
                        this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessForceDate');
                        this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessExpDate');
                        break;
                    case this._enums.MchNatureEnum.企业.id:
                        this.mchInfo.tempFilter.withoutBusiness = false;
                        break;
                    case this._enums.MchNatureEnum.事业单位.id:
                        this.mchInfo.tempFilter.withoutBusiness = false;
                        break;
                }
                console.log("无需营业执照信息", this.mchInfo.tempFilter.withoutBusiness)
            },
            testHandler(valNew, valOld) {
                console.log(valNew, valOld)
            },
            legalIdExpDateNonChangeHandler(valNew, valOld) { if(valNew) { this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.legalIdCardExpDate'); this.mchInfo.mchExtraInfo.legalIdCardExpDate='2099-12-31'; } else {this.mchInfo.mchExtraInfo.legalIdCardExpDate=null;} },
            businessExpDateNonChangeHandler(valNew, valOld) { if(valNew) { this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessExpDate'); if(!this.mchInfo.tempFilter.withoutBusiness) this.mchInfo.mchExtraInfo.businessExpDate='2099-12-31'; } else {this.mchInfo.mchExtraInfo.businessExpDate=null;} },
            respIsLegalChangeHandler(valNew, valOld) {
                if(valNew) {
                    this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.responsibleName');
                    this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.responsiblePhone');
                    this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.responsibleIdCardNo');
                    if(this.mchInfo.tempFilter.respIsLegal) {
                        this.mchInfo.mchExtraInfo.responsibleName = null;
                        this.mchInfo.mchExtraInfo.responsiblePhone = null;
                        this.mchInfo.mchExtraInfo.responsibleIdCardNo = null;
                    }
                }
            },
            businessTypeChangeHandler(valNew, valOld) {
                this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessType');
                switch (valNew) {
                    case this._enums.BusinessTypeEnum.营业执照.id:
                        this.mchInfo.tempFilter.withoutBusinessOther = false;
                        break;
                    case this._enums.BusinessTypeEnum.营业执照多证合一.id:
                        this.mchInfo.tempFilter.withoutBusinessOther = true;
                        break;
                    case this._enums.BusinessTypeEnum.事业单位法人证书.id:
                        this.mchInfo.tempFilter.withoutBusinessOther = false;
                        break;
                }
            },
            settAccountTypeChangeHandler(valNew, valOld) {
                this.$refs['baseMainFormRef'].clearValidate('mchSettleInfo.settAccountType');
                switch (valNew) {
                    case this._enums.SettleTypeEnum.对公结算.id:
                        this.mchInfo.tempFilter.withoutSettleToNoLegal = true;
                        this.mchInfo.mchSettleInfo.settAccountName = this.mchInfo.mchExtraInfo.businessName
                        break;
                    case this._enums.SettleTypeEnum.法人对私结算.id:
                        this.mchInfo.tempFilter.withoutSettleToNoLegal = true;
                        this.mchInfo.mchSettleInfo.settAccountName = this.mchInfo.mchExtraInfo.legalName
                        break;
                    case this._enums.SettleTypeEnum.非法人对私结算.id:
                        this.mchInfo.tempFilter.withoutSettleToNoLegal = false;
                        break;
                }
            },
            distIdChangeHandler(valNew, valOld) { this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.tempAreas'); },
            settBankCodeChangeHandler(valNew, valOld) { this.$refs['baseMainFormRef'].clearValidate('mchSettleInfo.settBankCode'); },
            businessArrChangeHandler(valNew, valOld) { this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.businessId'); },
            companyTypeChangeHandler(valNew, valOld) { this.$refs['baseMainFormRef'].clearValidate('mchExtraInfo.companyType'); },

            //////////////////////////////////////////////////////////////////////
            // 产品选中发生变化
            //////////////////////////////////////////////////////////////////////
            handleSelectionChange(val) {
                this.multipleSelection = val;

                // 更新对应渠道扩展信息的状态（已选中的产品代码数组中，存在该渠道对应产品，渠道status=1，否则，渠道status=0）。
                let selectRowProductCodeArr = this.getSelectRowProductCodeArr();
                this.mchInfo.userProductList.forEach( item => {
                    if(item.status===1) selectRowProductCodeArr.push(item.payProduct.productCode);
                });
                /**
                selectRowProductCodeArr.indexOf(this.tmpProdInfo.jhExt.productCode)===-1?this.tmpProdInfo.jhExt.status = 0:this.tmpProdInfo.jhExt.status = 1;
                selectRowProductCodeArr.indexOf(this.tmpProdInfo.slExt.productCode)===-1?this.tmpProdInfo.slExt.status = 0:this.tmpProdInfo.slExt.status = 1;
                selectRowProductCodeArr.indexOf(this.tmpProdInfo.slExtC.productCode)===-1?this.tmpProdInfo.slExtC.status = 0:this.tmpProdInfo.slExtC.status = 1;
                selectRowProductCodeArr.indexOf(this.tmpProdInfo.qrExt.productCode)===-1?this.tmpProdInfo.qrExt.status = 0:this.tmpProdInfo.qrExt.status = 1;
                */

                this.tExtBlobsData.forEach(itemExt => {
                    selectRowProductCodeArr.indexOf(itemExt.productCode) === -1 ? itemExt.status = 0 : itemExt.status = 1
                })

                this.$refs['prodTempFormRef'].clearValidate('tempProductCheck')
            },
            //////////////////////////////////////////////////////////////////////
            // 获取当前用户基础产品扣率信息
            //////////////////////////////////////////////////////////////////////
            handleProdTab() {
                if(this.inOptType==='INS' && this.mchInfo.userProductList.length===0) { // 新增 - 深度拷贝 产品费率信息，初始化状态未选中
                    this.mchInfo.userProductList = deepClone(this.arch_userBaseProductRateInfo);
                    this.mchInfo.userProductList.forEach( item => { item.status = 0; });
                }
                else if(this.inOptType==='UPD' || this.inOptType==='UPD_EXT' ) {
                    // 遍历当前商户产品列表，状态1选中，状态0取消选中。
                    this.mchInfo.userProductList.forEach( item => {
                        if(item.status===1) {
                            this.$refs.prodTable.toggleRowSelection(item,true);
                        }
                        else {
                            this.$refs.prodTable.toggleRowSelection(item,false);
                        }
                    });
                    // 不好的处理，可以选择隐藏一行，暂时没找到方法，直接弹出数组
                    this.mchInfo.userProductList.forEach( (item, index) => {
                        if(item.status===0) {
                            this.mchInfo.userProductList.splice(index, 1);
                        }
                    });

                }
            },
            //////////////////////////////////////////////////////////////////////
            // 获取所有选中的产品代码数组
            //////////////////////////////////////////////////////////////////////
            getSelectRowProductCodeArr() {
                // 获取 - 选中的产品信息
                let selectRow = this.$refs.prodTable.selection;
                let selectRowProductCodeArr = [];
                selectRow.forEach( item => { selectRowProductCodeArr.push(item.payProduct.productCode); });
                return selectRowProductCodeArr;
            },
            //////////////////////////////////////////////////////////////////////
            // 用传入对象 额外初始化一些 当前表单信息
            // 初始化 表单参数 到 特殊组件绑定参数 （展示渲染）
            //////////////////////////////////////////////////////////////////////
            initFormBef() {
                console.log("initFormBef");
                if (!this.mchInfo.tempFilter) this.mchInfo.tempFilter = {}
                if (!this.mchInfo.mchExtraInfo.tempAreas) this.mchInfo.mchExtraInfo.tempAreas = {};
                // 初始 - 区域组件绑定值
                this.mchInfo.mchExtraInfo.tempAreas.provId = this.mchInfo.mchExtraInfo.adsProvinceCode;
                this.mchInfo.mchExtraInfo.tempAreas.cityId = this.mchInfo.mchExtraInfo.adsCityCode;
                this.mchInfo.mchExtraInfo.tempAreas.distId = this.mchInfo.mchExtraInfo.adsAreaCode;
                // 初始 - 行业级联组件绑定值
                this.businessArr = this.mchInfo.mchExtraInfo.businessId;
                // 初始 - 注册资本
                if(this.isNum(this.mchInfo.mchExtraInfo.businessRegCapital)) {
                    this.mchInfo.mchExtraInfo.businessRegCapitalBak = this.mchInfo.mchExtraInfo.businessRegCapital/10000;
                }
                console.log("businessRegCapital", this.mchInfo.mchExtraInfo.businessRegCapital)
                console.log("businessRegCapitalBak", this.mchInfo.mchExtraInfo.businessRegCapitalBak)

                if(this.inOptType==='ADD_PRD') {
                    this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                }

                // 初始 - 渠道补充表单内的组件绑定值（目前只有收单协议照和状态）
                this.tExtBlobsData.forEach((item, index) => {
                    let prod = this.mchInfo.mchExtraChannelInfoWithBLOBsList.find( item2 => item.payChannelCode === item2.payChannelCode)
                    if (prod) {
                        // 直接拷贝导致enums中的desc配置参数被覆盖
                        // this.tExtBlobsData[index] = deepClone(prod)
                        item.settCycle = prod.settCycle
                        item.imgReceiptAgreementUrl = prod.imgReceiptAgreementUrl
                        item.imgMchUpdateUrl = prod.imgMchUpdateUrl
                        item.imgSettNonlegalAuthUrl = prod.imgSettNonlegalAuthUrl
                        item.imgMchZcdjbUrl = prod.imgMchZcdjbUrl
                    }
                })

                /**
                this.mchInfo.mchExtraChannelInfoWithBLOBsList.forEach( item => {
                    if(item.payChannelCode===this.tmpProdInfo.jhExt.payChannelCode) {
                        this.tmpProdInfo.jhExt.status = 1;
                        this.tmpProdInfo.jhExt.settCycle = item.settCycle;
                        this.tmpProdInfo.jhExt.imgReceiptAgreementUrl = item.imgReceiptAgreementUrl;
                        this.tmpProdInfo.jhExt.imgMchUpdateUrl = item.imgMchUpdateUrl;
                        this.tmpProdInfo.jhExt.imgSettNonlegalAuthUrl = item.imgSettNonlegalAuthUrl;
                        this.tmpProdInfo.jhExt.imgMchZcdjbUrl = item.imgMchZcdjbUrl;
                    }
                    if(item.payChannelCode===this.tmpProdInfo.slExt.payChannelCode) {
                        this.tmpProdInfo.slExt.status = 1;
                        this.tmpProdInfo.slExt.settCycle = item.settCycle;
                        this.tmpProdInfo.slExt.imgReceiptAgreementUrl = item.imgReceiptAgreementUrl;
                        this.tmpProdInfo.slExt.imgMchUpdateUrl = item.imgMchUpdateUrl;
                        this.tmpProdInfo.slExt.imgSettNonlegalAuthUrl = item.imgSettNonlegalAuthUrl;
                        this.tmpProdInfo.slExt.imgMchZcdjbUrl = item.imgMchZcdjbUrl;
                    }
                    if(item.payChannelCode===this.tmpProdInfo.slExtC.payChannelCode) {
                        this.tmpProdInfo.slExtC.status = 1;
                        this.tmpProdInfo.slExtC.settCycle = item.settCycle;
                        this.tmpProdInfo.slExtC.imgReceiptAgreementUrl = item.imgReceiptAgreementUrl;
                        this.tmpProdInfo.slExtC.imgMchUpdateUrl = item.imgMchUpdateUrl;
                        this.tmpProdInfo.slExtC.imgSettNonlegalAuthUrl = item.imgSettNonlegalAuthUrl;
                        this.tmpProdInfo.slExtC.imgMchZcdjbUrl = item.imgMchZcdjbUrl;
                    }
                    if(item.payChannelCode===this.tmpProdInfo.qrExt.payChannelCode) {
                        this.tmpProdInfo.qrExt.status = 1;
                        this.tmpProdInfo.qrExt.settCycle = item.settCycle;
                        this.tmpProdInfo.qrExt.imgReceiptAgreementUrl = item.imgReceiptAgreementUrl;
                        this.tmpProdInfo.qrExt.imgMchUpdateUrl = item.imgMchUpdateUrl;
                        this.tmpProdInfo.qrExt.imgSettNonlegalAuthUrl = item.imgSettNonlegalAuthUrl;
                        this.tmpProdInfo.qrExt.imgMchZcdjbUrl = item.imgMchZcdjbUrl;
                    }
                });
                 */


            },
            //////////////////////////////////////////////////////////////////////
            // 用当前表单信息 额外初始化一些 传入对象
            // 初始化 特殊组件绑定参数 到 表单参数 （提交后台）
            //////////////////////////////////////////////////////////////////////
            initFormAft() {
                console.log("initFormAft-inOptType", this.inOptType);

                // 补充 - 提交表单的产品信息
                console.log("补充 - 提交表单的产品信息");
                let selectRowProductCodeArr = this.getSelectRowProductCodeArr();

                /**
                if(selectRowProductCodeArr.length===0) {
                    this.$message.error("请选择支付产品!");
                    return false;
                }
                else {
                    // 遍历产品列表，根据选中行产品代码数组，更新状态
                    this.mchInfo.userProductList.forEach( item => { item.status = selectRowProductCodeArr.indexOf(item.payProduct.productCode)===-1?0:1; });
                }*/

                // 遍历产品列表，根据选中行产品代码数组，更新状态
                this.mchInfo.userProductList.forEach( item => { item.status = selectRowProductCodeArr.indexOf(item.payProduct.productCode)===-1?0:1; });

                if(this.inOptType==='INS' || this.inOptType==='ADD_PRD') {
                    // 补充 - 渠道扩展信息 - 按产品选中状态，push添加 渠道代码、渠道收单协议照片
                    this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                    this.tExtBlobsData.forEach(item => {
                        if (item.status === 1) {
                            this.mchInfo.mchExtraChannelInfoWithBLOBsList.push(item)
                        }
                    })
                    /**
                    if(this.tmpProdInfo.jhExt.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode: this.tmpProdInfo.jhExt.payChannelCode,
                            settCycle: this.tmpProdInfo.jhExt.settCycle,
                            imgReceiptAgreementUrl: this.tmpProdInfo.jhExt.imgReceiptAgreementUrl,
                            imgMchUpdateUrl: this.tmpProdInfo.jhExt.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl: this.tmpProdInfo.jhExt.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.jhExt.imgMchZcdjbUrl
                        } );
                    if(this.tmpProdInfo.slExt.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode:this.tmpProdInfo.slExt.payChannelCode,
                            settCycle: this.tmpProdInfo.slExt.settCycle,
                            imgReceiptAgreementUrl:this.tmpProdInfo.slExt.imgReceiptAgreementUrl,
                            imgMchUpdateUrl:this.tmpProdInfo.slExt.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl:this.tmpProdInfo.slExt.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.slExt.imgMchZcdjbUrl
                        } );
                    if(this.tmpProdInfo.slExtC.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode:this.tmpProdInfo.slExtC.payChannelCode,
                            settCycle: this.tmpProdInfo.slExtC.settCycle,
                            imgReceiptAgreementUrl:this.tmpProdInfo.slExtC.imgReceiptAgreementUrl,
                            imgMchUpdateUrl:this.tmpProdInfo.slExtC.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl:this.tmpProdInfo.slExtC.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.slExtC.imgMchZcdjbUrl
                        } );
                    if(this.tmpProdInfo.qrExt.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode:this.tmpProdInfo.qrExt.payChannelCode,
                            settCycle: this.tmpProdInfo.qrExt.settCycle,
                            imgReceiptAgreementUrl:this.tmpProdInfo.qrExt.imgReceiptAgreementUrl,
                            imgMchUpdateUrl:this.tmpProdInfo.qrExt.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl:this.tmpProdInfo.qrExt.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.qrExt.imgMchZcdjbUrl
                        } );
                    */
                }
                else if(this.inOptType==='UPD' || this.inOptType==='UPD_EXT' ) {
                    this.mchInfo.mchExtraChannelInfoWithBLOBsList.forEach( item => {
                        this.tExtBlobsData.forEach(itemExt => {
                            if (item.payChannelCode === itemExt.payChannelCode) {
                                item.settCycle = itemExt.settCycle
                                item.imgReceiptAgreementUrl = itemExt.imgReceiptAgreementUrl
                                item.imgMchUpdateUrl = itemExt.imgMchUpdateUrl
                                item.imgSettNonlegalAuthUrl = itemExt.imgSettNonlegalAuthUrl
                                item.imgMchZcdjbUrl = null
                            }
                        })
                        /**

                        if(item.payChannelCode===this.tmpProdInfo.jhExt.payChannelCode) {
                            item.settCycle = this.tmpProdInfo.jhExt.settCycle;
                            item.imgReceiptAgreementUrl = this.tmpProdInfo.jhExt.imgReceiptAgreementUrl;
                            item.imgMchUpdateUrl = this.tmpProdInfo.jhExt.imgMchUpdateUrl;
                            item.imgSettNonlegalAuthUrl = this.tmpProdInfo.jhExt.imgSettNonlegalAuthUrl;
                            item.imgMchZcdjbUrl = this.tmpProdInfo.jhExt.imgMchZcdjbUrl;
                        }
                        else if(item.payChannelCode===this.tmpProdInfo.slExt.payChannelCode) {
                            item.settCycle = this.tmpProdInfo.slExt.settCycle;
                            item.imgReceiptAgreementUrl = this.tmpProdInfo.slExt.imgReceiptAgreementUrl;
                            item.imgMchUpdateUrl = this.tmpProdInfo.slExt.imgMchUpdateUrl;
                            item.imgSettNonlegalAuthUrl = this.tmpProdInfo.slExt.imgSettNonlegalAuthUrl;
                            item.imgMchZcdjbUrl  = this.tmpProdInfo.slExt.imgMchZcdjbUrl;
                        }
                        else if(item.payChannelCode===this.tmpProdInfo.slExtC.payChannelCode) {
                            item.settCycle = this.tmpProdInfo.slExtC.settCycle;
                            item.imgReceiptAgreementUrl = this.tmpProdInfo.slExtC.imgReceiptAgreementUrl;
                            item.imgMchUpdateUrl = this.tmpProdInfo.slExtC.imgMchUpdateUrl;
                            item.imgSettNonlegalAuthUrl = this.tmpProdInfo.slExtC.imgSettNonlegalAuthUrl;
                            item.imgMchZcdjbUrl  = this.tmpProdInfo.slExtC.imgMchZcdjbUrl;
                        }
                        else if(item.payChannelCode===this.tmpProdInfo.qrExt.payChannelCode) {
                            item.settCycle = this.tmpProdInfo.qrExt.settCycle;
                            item.imgReceiptAgreementUrl = this.tmpProdInfo.qrExt.imgReceiptAgreementUrl;
                            item.imgMchUpdateUrl = this.tmpProdInfo.qrExt.imgMchUpdateUrl;
                            item.imgSettNonlegalAuthUrl = this.tmpProdInfo.qrExt.imgSettNonlegalAuthUrl;
                            item.imgMchZcdjbUrl  = this.tmpProdInfo.qrExt.imgMchZcdjbUrl;
                        }
                         */
                    });
                }
                /**
                else if(this.inOptType==='ADD_PRD') {
                    this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                    if(this.tmpProdInfo.jhExt.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode: this.tmpProdInfo.jhExt.payChannelCode,
                            settCycle: this.tmpProdInfo.jhExt.settCycle,
                            imgReceiptAgreementUrl: this.tmpProdInfo.jhExt.imgReceiptAgreementUrl,
                            imgMchUpdateUrl: this.tmpProdInfo.jhExt.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl: this.tmpProdInfo.jhExt.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.jhExt.imgMchZcdjbUrl

                        } );
                    if(this.tmpProdInfo.slExt.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode:this.tmpProdInfo.slExt.payChannelCode,
                            settCycle: this.tmpProdInfo.slExt.settCycle,
                            imgReceiptAgreementUrl:this.tmpProdInfo.slExt.imgReceiptAgreementUrl,
                            imgMchUpdateUrl:this.tmpProdInfo.slExt.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl:this.tmpProdInfo.slExt.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.slExt.imgMchZcdjbUrl
                        } );
                    if(this.tmpProdInfo.slExtC.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode:this.tmpProdInfo.slExtC.payChannelCode,
                            settCycle: this.tmpProdInfo.slExtC.settCycle,
                            imgReceiptAgreementUrl:this.tmpProdInfo.slExtC.imgReceiptAgreementUrl,
                            imgMchUpdateUrl:this.tmpProdInfo.slExtC.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl:this.tmpProdInfo.slExtC.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.slExtC.imgMchZcdjbUrl
                        } );
                    if(this.tmpProdInfo.qrExt.status===1)
                        this.mchInfo.mchExtraChannelInfoWithBLOBsList.push( {
                            payChannelCode:this.tmpProdInfo.qrExt.payChannelCode,
                            settCycle: this.tmpProdInfo.qrExt.settCycle,
                            imgReceiptAgreementUrl:this.tmpProdInfo.qrExt.imgReceiptAgreementUrl,
                            imgMchUpdateUrl:this.tmpProdInfo.qrExt.imgMchUpdateUrl,
                            imgSettNonlegalAuthUrl:this.tmpProdInfo.qrExt.imgSettNonlegalAuthUrl,
                            imgMchZcdjbUrl: this.tmpProdInfo.qrExt.imgMchZcdjbUrl
                        } );
                }*/


                // 补充 - 商户信息 - 创建方式（1.PC），创建IP（通过搜狐API获取）
                this.mchInfo.createWay = 1;
                this.mchInfo.createIp = "127.0.0.1";//returnCitySN["cip"];

                return true;
            },
            readTemp() {
                let data = localStorage.getItem('mch-base-form');
                if (data !== null) {
                    this.mchInfo = deepClone(JSON.parse(data));
                    this.initFormBef();
                    console.log("read-localStorage", JSON.stringify(this.mchInfo))
                    this.compAreaKey = Date.now()
                    this.compImgUploadKey = Date.now()
                    this.compBankSelectKey = Date.now()
                    localStorage.removeItem('mch-base-form')
                    this.hasBaseMchStore = false
                    this.$message.success("读取缓存成功，又可以愉快的工作了！");
                }
            },
            saveTemp() {
                this.initFormAft();
                localStorage.setItem('mch-base-form', JSON.stringify(this.mchInfo));
                this.hasBaseMchStore = true
                this.$message.success("暂存表单成功，喝杯奶茶，休息一下吧！");
                // console.log("save-localStorage", JSON.stringify(this.mchInfo))
            },
            checkForm(step) {
                return new Promise((resolve, reject) => {
                    switch (step) {
                        case 0:
                            console.log("checkForm->[base-main-form]");
                            this.$refs['baseMainFormRef'].validate(valid => { valid?resolve(true):reject("商户基本信息不完整，请检查!") });
                            break;
                        case 1:
                            console.log("checkForm->[sett-sub-form]");
                            this.$refs['settSubFormRef'].validate(valid => { valid?resolve(true):reject("商户结算账户信息不完整，请检查!") });
                            break;
                        case 2:
                            console.log("checkForm->[prod-temp-form]");
                            let selectRowProductCodeArr = this.getSelectRowProductCodeArr();
                            if(selectRowProductCodeArr.length===0) {
                                reject("请选择支付产品!")
                            } else {
                                resolve(true)
                            }
                            // this.$refs['prodTempFormRef'].validate(valid => { valid?resolve(true):reject("商户产品渠道信息不完整，请检查!") });
                            break;
                        default:
                            reject("check未知表单，请刷新重试!")
                            break
                    }
                })
            },
            async stepNext() {
                try{
                    await this.checkForm(Number(this.stepTab));
                    if (this.stepTab<2) { // 非提交
                        this.stepTab++;
                        this.stepTab += "";
                        if (this.stepTab===this.MAX_TAB_IDX) {
                            this.handleProdTab();
                        }
                    } else { // 确认提交
                        if(!this.initFormAft()) // 提交准备
                            return;

                        switch (this.inOptType) {
                            case 'UPD_EXT':
                            case 'UPD':
                                this.updateMchInfo(); // 商户进件修改
                                break;
                            case 'INS':
                                this.insertMchInfo(); // 商户进件
                                break;
                            case 'ADD_PRD':
                                this.addProductChannel();
                                break;
                            default:
                                this.$message.error("未知提交操作!");
                                break;
                        }
                    }
                } catch(error){
                    this.$message.error(error);
                }
            },
            stepPre() {
                this.stepTab--;
                this.stepTab += "";
                if (this.stepTab===this.MAX_TAB_IDX) {
                    this.handleProdTab();
                }
            },
            //////////////////////////////////////////////////////////////////////
            // 提交-添加产品
            //////////////////////////////////////////////////////////////////////
            addProductChannel() {
                this.putting = true;
                this.putRequest("/mch/addMchProduct", this.mchInfo).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    } else {
                        console.log("addMch failed");
                        this.putting = false
                    }
                })
            },
            //////////////////////////////////////////////////////////////////////
            // 提交-新增商户
            //////////////////////////////////////////////////////////////////////
            insertMchInfo() {
                this.putting = true;
                this.postRequest("/mch/addMch", this.mchInfo).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    } else {
                        console.log("addMch failed");
                        this.putting = false
                    }
                })
            },
            //////////////////////////////////////////////////////////////////////
            // 提交-修改商户
            //////////////////////////////////////////////////////////////////////
            updateMchInfo() {
                this.putting = true;
                this.putRequest("/mch/updateMch", this.mchInfo).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    } else {
                        console.log("updateMch failed");
                        this.putting = false;
                    }
                })
            },
            isNum(val) {
                if(val === "" || val ==null){
                    return false;
                }
                return !isNaN(val);
            },
            emitToParent() {
                this.$emit('update:outDlgClosed', true);
            }
        }
    }
</script>

<style lang="less"  scoped>

    .cls-main {
        .cls-input-number {
            :deep(input::-webkit-outer-spin-button) {
                -webkit-appearance: none;
            }
            :deep(input::-webkit-inner-spin-button) {
                -webkit-appearance: none;
            }
            :deep(input[type="number"]) {
                -moz-appearance: textfield;
            }
        }

        .cls-step {
        }

        :deep(.el-dialog__body)  {
            overflow-y: hidden;
        }

        /*
        .el-steps--simple {
            height: 40px;
            position: relative;
        }
       .el-steps--simple::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #E4E7ED;
            z-index: 1;
        }*/

        .el-steps--horizontal {
            height: 50px;
            position: relative;
        }
        .el-steps--horizontal::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: #E4E7ED;
            z-index: 1;
        }
        :deep(.el-step__title.is-process)  {
            font-weight: normal;
        }
        :deep(.el-step__icon-inner)  {
            font-weight: normal;
        }
        :deep(.el-step__icon.is-text)  {
            border-radius: 50%;
            border: 1px solid inherit;
        }
    }

    /* */
    .cls-tabs {
        :deep(.el-tabs__header)  {
            display: none;
        }
    }

    .cls-pro-form-item {
        .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
            line-height: 0;
        }
    }

    .m-top--10 {
        margin-top: -10px;
    }

    .cls-btn-save {
        position: absolute;
        top: 5px;
        left: 15px;
        z-index: 999;
    }


</style>
